"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
const SvgIcon = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M680-119q-8 0-16-2t-15-7l-120-70q-14-8-21.5-21.5T500-249v-141q0-16 7.5-29.5T529-441l120-70q7-5 15-7t16-2 15.5 2.5T710-511l120 70q14 8 22 21.5t8 29.5v141q0 16-8 29.5T830-198l-120 70q-7 4-14.5 6.5T680-119m-520-41q-33 0-56.5-23.5T80-240v-32q0-33 17-62t47-44q56-28 117-44.5T385-441q8 0 14 3.5t10 9.5 5 13.5-1 15.5q-6 20-9 40.5t-3 40.5q0 30 6.5 59.5T427-201q3 8 3 15t-4 13-9.5 9.5T403-160zm240-320q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47m186 74 94 55 94-55-94-54zm124 208 90-52v-110l-90 53zm-150-52 90 53v-109l-90-53z"
}), 'DeployedCodeAccountFilledRounded', {
  viewBox: "0 -960 960 960"
});
var _default = exports.default = SvgIcon;